import React from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';

function CreateBudgetMessage({ content, totalBudgetValue, potValue, earning }) {
  const budgetValue = Math.abs(totalBudgetValue - potValue);
  const sortValue = Math.abs(totalBudgetValue - earning);
  const isOverBudget = earning - totalBudgetValue < 0;

  return (
    <div className="spendings-createbudget-message">
      <div
        className={`spendings-message${
          isOverBudget ? ' spendings-message-rejig' : ''
        }`}
      >
        <h3>
          {isOverBudget && <span className="icon icon-information" />}
          {isOverBudget
            ? content.spendingCreateMessageTitleText2
            : content.spendingCreateMessageTitleText1}
        </h3>
        <p>
          {content.spendingCreateMessageCopyText1}{' '}
          <b>{NumberUtils.appendCurrency('{}', budgetValue)}</b>
          <br />
          {content.spendingCreateMessageCopyText2}{' '}
          <b>{NumberUtils.appendCurrency('{}', potValue)}</b>.
        </p>
        <p className="lower-para">
          {`${
            isOverBudget
              ? content.spendingCreateMessageCopyText5
              : content.spendingCreateMessageCopyText3
          } `}
          <span className="sortValue">
            <b>{NumberUtils.appendCurrency('{}', sortValue)}</b>
            {!isOverBudget && ' '}
            {!isOverBudget && content.spendingCreateMessageCopyText4}
          </span>
          .
        </p>
      </div>
    </div>
  );
}

CreateBudgetMessage.propTypes = {
  content: PropTypes.object,
  totalBudgetValue: PropTypes.number,
  potValue: PropTypes.number,
  earning: PropTypes.number,
};

export { CreateBudgetMessage };
